import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import {
  sumOfGroupTotals,
  totalRowPercentageWithGrandTotals,
} from '../../../../../react-table/helpers/rowTotals';
import CarditNestingLocationReportMode from "./CarditNestingLocationReportMode";

export const getDetailsTabNavigationProps = originExchangeOfficesData => (rowInfo, index) => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.CARDIT_NESTING_DETAILS.id,
    mainReportId: ReportDefinitions.CARDIT_NESTING_LOCATION.id,
    requestParams: {
      carrierCode: rowInfo.row['carrier'], // eslint-disable-line
      originAirport: rowInfo.row['originAirport'][index], // eslint-disable-line
      originExchangeOffices: originExchangeOfficesData.originExchangeOffices,
      isSubtotal: index === 0,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {}
);

export default (data, originExchangeOfficesData, mode = CarditNestingLocationReportMode.percentage) => {
  const {
    NonZeroNumberColumn,
    MultilineColumn,
    MultilineNumberGroupedColumn,
    MultilinePercentageGroupedColumn,
    MultilineNumberNavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new MultilineColumn('Carrier', 'carrier')
          .withTotalHeader('Total', 'bg-total-grey'),
        new MultilineColumn('Origin airport', 'originAirport')
          .withTotalHeader('', 'bg-total-grey'),
      ],
    },
    {
      Header: 'Consignment',
      columns: [
        new MultilineNumberGroupedColumn('Total', 'consignment.total')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey'),
        new MultilineNumberGroupedColumn('CJID nested', 'consignment.cjidNested', true, 'consignment.pctCjidNested')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarditNestingLocationReportMode.number),
        new MultilineNumberGroupedColumn('ULD ID nested', 'consignment.uldIdnested', true, 'consignment.pctUldIdNested')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarditNestingLocationReportMode.number),
        new MultilinePercentageGroupedColumn('% CJID nested', 'consignment.pctCjidNested', true, 'consignment.cjidNested')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['consignment.cjidNested', 'consignment.total']), 'bg-total-grey')
          .withShow(mode === CarditNestingLocationReportMode.percentage),
        new MultilinePercentageGroupedColumn('% ULD ID nested', 'consignment.pctUldIdNested', true, 'consignment.uldIdnested')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['consignment.uldIdnested', 'consignment.total']), 'bg-total-grey')
          .withShow(mode === CarditNestingLocationReportMode.percentage),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new MultilineNumberNavigationWithFooterColumn(
          new NonZeroNumberColumn('Total', 'receptacles.total')
            .withTotalHeader(sumOfGroupTotals, 'bg-total-grey'),
          getDetailsTabNavigationProps(originExchangeOfficesData),
        ),
        new MultilineNumberGroupedColumn('CJID nested', 'receptacles.cjidNested', true, 'receptacles.pctCjidNested')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarditNestingLocationReportMode.number),
        new MultilineNumberGroupedColumn('ULD ID nested', 'receptacles.uldIdnested', true, 'receptacles.pctUldIdNested')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarditNestingLocationReportMode.number),
        new MultilinePercentageGroupedColumn('% CJID nested', 'receptacles.pctCjidNested', true, 'receptacles.cjidNested')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['receptacles.cjidNested', 'receptacles.total']), 'bg-total-grey')
          .withShow(mode === CarditNestingLocationReportMode.percentage),
        new MultilinePercentageGroupedColumn('% ULD ID nested', 'receptacles.pctUldIdNested', true, 'receptacles.uldIdnested')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['receptacles.uldIdnested', 'receptacles.total']), 'bg-total-grey')
          .withShow(mode === CarditNestingLocationReportMode.percentage),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.CARDIT_NESTING_DETAILS.id,
        mainReportId: ReportDefinitions.CARDIT_NESTING_LOCATION.id,
        requestParams: {
          isTotal: originExchangeOfficesData.carrierCode === '*', // since report expected to have one only group - * is handled on cape-be by reverting it back to ''
          isSubtotal: originExchangeOfficesData.carrierCode !== '*', // since report expected to have one only group - * is handled on cape-be by reverting it back to ''
          carrierCode: originExchangeOfficesData.carrierCode,
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
